import * as Constants from './constants'

const initialState = {
  list: [],
  item: {},
  type: Constants.NHOM_KHACHHANG_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  formData: {},
  callback: function () { },
}

const reducer = function nganhHangReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.NHOM_KHACHHANG_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.NHOM_KHACHHANG_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        listNganhHang: action.data.records,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.NHOM_KHACHHANG_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.NHOM_KHACHHANG_DETAIL_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.NHOM_KHACHHANG_DETAIL_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data.records || {},
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.NHOM_KHACHHANG_DETAIL_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.NHOM_KHACHHANG_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.NHOM_KHACHHANG_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }]
      }

    case Constants.NHOM_KHACHHANG_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.NHOM_KHACHHANG_REMOVE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.NHOM_KHACHHANG_REMOVE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        listRequesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.NHOM_KHACHHANG_REMOVE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/NhomKhachHang/reducer.js